import { createBlock, mergeBlock, t } from "@easy-email-pro-core/utils";

import { BasicType, ElementCategory } from "@easy-email-pro-core/constants";
import { ElementDefinition, GroupElement } from "@easy-email-pro-core/typings";
import { BasicBlock } from "@easy-email-pro-core/components";
import React from "react";

const defaultData: ElementDefinition<GroupElement>["defaultData"] = {
  attributes: {
    direction: "ltr",
    "vertical-align": "top",
    "padding-top": "0px",
    "padding-right": "0px",
    "padding-bottom": "0px",
    "padding-left": "0px",
    // width: "100%", 需要移除，否则 Component设置的时候不生效
  },
  data: {},
};

export const Group = createBlock<GroupElement>({
  get name() {
    return t("Group");
  },
  defaultData,
  type: BasicType.GROUP,
  create: (payload) => {
    const defaultData: GroupElement = {
      type: BasicType.GROUP,
      data: {},
      attributes: {
        width: "100%",
      },
      children: [],
    };
    return mergeBlock(defaultData, payload);
  },
  category: ElementCategory.GROUP,
  render(params) {
    return <BasicBlock params={params} tag="mj-group" />;
  },
});
